/*
 * machsport FAQ-Suchindex
 * Datei: assets/machsport-faq-search-index.js
 *
 * Vollständiger Index auf Basis des übermittelten Seitenquelltexts
 * der FAQ-Seite /pages/avada-faqs.
 *
 * Enthalten: 142 Fragen und Antworten aus 15 FAQ-Bereichen.
 */

(function () {
  'use strict';

  var FAQ_PAGE_URL = '/pages/avada-faqs';

  var FAQ_INDEX = [
  {
    "id": "bietet-machsport-eine-bestpreisgarantie-an",
    "category": "Bestpreisgarantie & Preise",
    "question": "Bietet machsport eine Bestpreisgarantie an?",
    "answer": "Wir möchten unseren Kund:innen immer Qualität und Service zu Top-Preisen liefern. Darum bieten wir dir die machsport Bestpreisgarantie.",
    "keywords": []
  },
  {
    "id": "wann-ist-die-bestpreisgarantie-gueltig",
    "category": "Bestpreisgarantie & Preise",
    "question": "Wann ist die Bestpreisgarantie gültig?",
    "answer": "Die Bestpreisgarantie gilt, wenn du bei einem Einkauf im Shop einen unserer lagernden Artikel bei einem anderen Händler günstiger siehst. Zeige einem machsport Mitarbeiter den günstigeren Preis, oder schick uns eine E-Mail mit dem Link zum entsprechenden Angebot. Wenn wir das Angebot geprüft haben und alles OK ist, dann bekommst du auch bei uns den Artikel zum günstigeren Preis oder die Differenz erstattet.",
    "keywords": []
  },
  {
    "id": "welche-voraussetzungen-fuer-die-bestpreisgarantie-gibt-es",
    "category": "Bestpreisgarantie & Preise",
    "question": "Welche Voraussetzungen für die Bestpreisgarantie gibt es?",
    "answer": "Die einzige Voraussetzung für die Bestpreisgarantie ist, dass der Händler des betreffenden Artikels seinen Geschäftssitz in Österreich hat, und der Artikel in der gewünschten Ausführung natürlich auch lagernd ist. Falls versehentlich ein Artikel in unserem Onlineshop günstiger ausgewiesen ist als im Shop, dann bekommst du natürlich ebenfalls automatisch den niedrigeren Preis verrechnet bzw. erstattet.",
    "keywords": []
  },
  {
    "id": "wie-ergibt-sich-der-vergleichspreis",
    "category": "Bestpreisgarantie & Preise",
    "question": "Wie ergibt sich der Vergleichspreis?",
    "answer": "Der Vergleichspreis ergibt sich aus dem Artikelpreis und den Versandkosten des günstigeren Händlers.",
    "keywords": []
  },
  {
    "id": "gelten-die-onlinepreise-auch-in-den-filialen",
    "category": "Bestpreisgarantie & Preise",
    "question": "Gelten die Onlinepreise auch in den Filialen?",
    "answer": "Ja. Das was du online zahlst, zahlst du auch in unseren Filialen und natürlich auch umgekehrt.",
    "keywords": []
  },
  {
    "id": "wie-koennen-die-gutscheine-eingeloest-werden",
    "category": "Gutscheine",
    "question": "Wie können die Gutscheine eingelöst werden?",
    "answer": "Gutscheine können direkt in unseren Filialen oder im Onlineshop eingelöst werden.",
    "keywords": []
  },
  {
    "id": "haben-die-gutscheine-ein-ablaufdatum",
    "category": "Gutscheine",
    "question": "Haben die Gutscheine ein Ablaufdatum?",
    "answer": "Nein. Unsere Gutscheine sind an kein Datum gebunden und können vom Zeitpunkt des Erwerbs bis zur Verwendung des Gutscheins eingelöst werden. Gutscheine sind auch übertragbar.",
    "keywords": []
  },
  {
    "id": "kann-jeder-gutschein-fuer-alle-produkte-verwendet-werden",
    "category": "Gutscheine",
    "question": "Kann jeder Gutschein für alle Produkte verwendet werden?",
    "answer": "Ja. Wir haben 4 unterschiedliche Gutscheinthemen, jeder Gutschein kann aber für das gesamte Sortiment verwendet werden. Du hast die Qual der Wahl. Wähle den Gutschein der am Besten zu dem Beschenkten oder dir passt.",
    "keywords": []
  },
  {
    "id": "wie-erhalte-ich-einen-willkommensgutschein",
    "category": "Gutscheine",
    "question": "Wie erhalte ich einen Willkommensgutschein?",
    "answer": "Melde dich zu unserem Newsletter an und du bekommst von uns einen Willkommensgutschein. Dieser kann sofort, oder später, für deine Bestellung verwendet werden. Weitere Informationen sowie den Link zur Newsletter-Anmeldung findest du im FAQ Newsletter & Gewinnspiele , etwas weiter unten.",
    "keywords": []
  },
  {
    "id": "mein-gutschein-funktioniert-nicht-was-kann-ich-tun",
    "category": "Gutscheine",
    "question": "Mein Gutschein funktioniert nicht, was kann ich tun?",
    "answer": "Du hast deinen Gutscheincode im Checkout des Onlineshops eingetragen und es funktioniert nicht? Bitte beachte, dass manche Gutscheincodes einen Mindestbestellwert haben. Weiters können Gutscheine nicht miteinander kombiniert werden.",
    "keywords": []
  },
  {
    "id": "kann-ich-den-newsletter-willkommensgutschein-auch-direkt-in-den-filialen-einloesen",
    "category": "Gutscheine",
    "question": "Kann ich den Newsletter Willkommensgutschein auch direkt in den Filialen einlösen?",
    "answer": "Nein. Der Willkommensgutschein für den Newsletter ist ausschließlich in unserem Onlineshop einzulösen. Wir haben online und stationär die gleichen Preise. Du kannst dir die Ware zusenden lassen, oder nach Bestellung auch gerne in unserer Filiale abholen (Click&Collect).",
    "keywords": []
  },
  {
    "id": "gibt-es-eine-uebersicht-ueber-alle-gutscheine-und-aktionen",
    "category": "Gutscheine",
    "question": "Gibt es eine Übersicht über alle Gutscheine und Aktionen?",
    "answer": "Ja. Alle Gutscheine und Aktionen haben wir für dich auf einer Seite gesammelt. Erfahre mehr und klicke hier .",
    "keywords": []
  },
  {
    "id": "wie-kann-ich-bei-machsport-zahlen",
    "category": "Zahlung & Bestellung",
    "question": "Wie kann ich bei machsport zahlen?",
    "answer": "Wir bieten dir flexible Zahlungsmöglichkeiten – von Kreditkarte über PayPal bis hin zu Kauf auf Rechnung. Bei uns kannst du sicher und bequem bezahlen, ganz nach deinen Wünschen. Deine Zufriedenheit und Sicherheit stehen dabei immer an erster Stelle!",
    "keywords": []
  },
  {
    "id": "welche-zahlungsmoeglichkeiten-gibt-es",
    "category": "Zahlung & Bestellung",
    "question": "Welche Zahlungsmöglichkeiten gibt es?",
    "answer": "Wir bieten eine Vielzahl an Zahlungsmöglichkeiten an. Eine Übersicht über alle Zahlungsmöglichkeiten findest du hier .",
    "keywords": []
  },
  {
    "id": "sind-meine-daten-bei-machsport-sicher",
    "category": "Zahlung & Bestellung",
    "question": "Sind meine Daten bei machsport sicher?",
    "answer": "Deine Daten sind bei uns in besten Händen. Wir setzen auf modernste Sicherheitsstandards, um deine persönlichen Informationen zu schützen. Du kannst dich auf einen sicheren und vertrauenswürdigen Umgang mit deinen Daten verlassen – für ein sorgenfreies Einkaufserlebnis!",
    "keywords": []
  },
  {
    "id": "warum-wurde-meine-kreditkartenzahlung-abgelehnt",
    "category": "Zahlung & Bestellung",
    "question": "Warum wurde meine Kreditkartenzahlung abgelehnt?",
    "answer": "Die häufigste Ursache ist, dass deine Bank eine 3D Secure-Authentifizierung (z. B. „Verified by Visa“ oder „Mastercard Identity Check“) verlangt hat, aber die Authentifizierung nicht erfolgreich abgeschlossen wurde. In solchen Fällen wird die Zahlung automatisch abgelehnt – zu deinem eigenen Schutz.",
    "keywords": []
  },
  {
    "id": "was-ist-3d-secure-3ds",
    "category": "Zahlung & Bestellung",
    "question": "Was ist 3D Secure (3DS)?",
    "answer": "3D Secure ist ein zusätzlicher Sicherheitsschritt bei Online-Zahlungen mit Kreditkarte. Du wirst dabei meist auf eine Seite deiner Bank weitergeleitet, wo du dich mit einem Code, einer App oder biometrisch (z. B. Face ID) authentifizieren musst.",
    "keywords": []
  },
  {
    "id": "wird-3d-secure-bei-machsport-unterstuetzt",
    "category": "Zahlung & Bestellung",
    "question": "Wird 3D Secure bei machsport unterstützt?",
    "answer": "Ja, unser Shop unterstützt 3D Secure vollständig über Shopify Payments. Wenn deine Bank 3DS verlangt, wird die Authentifizierung automatisch gestartet.",
    "keywords": []
  },
  {
    "id": "ich-habe-keinen-3d-secure-code-erhalten-was-nun",
    "category": "Zahlung & Bestellung",
    "question": "Ich habe keinen 3D Secure-Code erhalten – was nun?",
    "answer": "Bitte prüfe: Ob deine Karte für Online-Zahlungen und 3D Secure freigeschaltet ist. Ob deine Bank-App korrekt eingerichtet ist. Ob du eine SMS oder Push-Benachrichtigung übersehen hast. Wenn du weiterhin keine 3DS-Bestätigung erhältst, kontaktiere bitte deine Bank, da wir darauf keinen Einfluss haben.",
    "keywords": []
  },
  {
    "id": "ich-wurde-gar-nicht-nach-3d-secure-gefragt-ist-das-sicher",
    "category": "Zahlung & Bestellung",
    "question": "Ich wurde gar nicht nach 3D Secure gefragt – ist das sicher?",
    "answer": "Ja. Nicht alle Transaktionen erfordern 3DS. In einigen Fällen entscheidet deine Bank, dass keine Authentifizierung notwendig ist – z. B. bei kleineren Beträgen oder wenn du als vertrauenswürdiger Kunde eingestuft wirst.",
    "keywords": []
  },
  {
    "id": "was-kann-ich-tun-wenn-meine-zahlung-trotzdem-nicht-funktioniert",
    "category": "Zahlung & Bestellung",
    "question": "Was kann ich tun, wenn meine Zahlung trotzdem nicht funktioniert?",
    "answer": "Du kannst Folgendes versuchen: Verwende eine andere Kreditkarte. Nutze eine alternative Zahlungsmethode wie PayPal, Klarna, Apple Pay oder Andere. Kontaktiere deine Bank und frage, ob die Karte für 3D Secure & Online-Käufe aktiviert ist.",
    "keywords": []
  },
  {
    "id": "alles-ueber-kauf-auf-rechnung",
    "category": "Zahlung & Bestellung",
    "question": "Alles über Kauf auf Rechnung!",
    "answer": "Du erhältst deine Ware zuerst und bezahlst den Rechnungsbetrag erst nach Erhalt der Rechnung innerhalb der angegebenen Zahlungsfrist direkt an Payolution. Wie lange habe ich Zeit, die Rechnung zu bezahlen? Die Zahlungsfrist beträgt 14 Tage ab Rechnungsdatum, die Zahlung erfolgt allerdings direkt an Payolution. Fallen zusätzliche Kosten an? Bei fristgerechter Zahlung fallen keine zusätzlichen Kosten an. Bei Zahlungsverzug können gesetzliche Verzugszinsen sowie Mahngebühren durch Payolution entstehen. Was passiert bei einer Retoure? Bei einer Rücksendung wird der Rechnungsbetrag entsprechend angepasst. Bereits geleistete Zahlungen werden von Payolution rückerstattet oder mit dem offenen Betrag verrechnet. An wen wende ich mich bei Fragen zur Rechnung? Fragen zur Rechnung oder Zahlung richtest du bitte direkt an Payolution. Die Kontaktdaten findest du auf deiner Rechnung oder in der Zahlungsinformation per E-Mail.",
    "keywords": []
  },
  {
    "id": "alles-ueber-ratenzahlung",
    "category": "Zahlung & Bestellung",
    "question": "Alles über Ratenzahlung!",
    "answer": "Der Rechnungsbetrag wird in monatlichen Raten beglichen. Die Laufzeit wird während des Checkouts ausgewählt. Der Ratenzahlungsvertrag kommt direkt zwischen dir und Payolution zustande. Welche Laufzeiten sind möglich? Es sind Laufzeiten von bis zu 12 Monaten möglich. Die konkret verfügbaren Optionen hängen vom Bestellwert und der Bonitätsprüfung ab. Wie hoch sind die Zinsen? Der Endkundenzinssatz beträgt 9,95 % p. a. Weitere Gebühren fallen bei vertragsgemäßer Zahlung nicht an. Kann ich den Ratenkauf vorzeitig ablösen? In der Regel ist eine vorzeitige Rückzahlung möglich. Die genauen Bedingungen sind im Ratenzahlungsvertrag von Payolution geregelt. Was passiert bei Zahlungsverzug? Bei verspäteter Zahlung können Verzugszinsen und Mahngebühren anfallen. Diese werden von Payolution erhoben und transparent ausgewiesen.",
    "keywords": []
  },
  {
    "id": "alle-informationen-zur-direktueberweisung",
    "category": "Zahlung & Bestellung",
    "question": "Alle Informationen zur Direktüberweisung!",
    "answer": "Du bezahlst den Rechnungsbetrag direkt während des Bestellvorgangs über dein vertrautes Online-Banking. Die Zahlung wird in Echtzeit bestätigt. Welche Banken werden unterstützt? Payolution unterstützt eine große Anzahl nationaler und internationaler Banken aus Österreich, Deutschland und weiteren EU-Ländern. Die verfügbaren Banken werden dir im Checkout angezeigt. Ist die Direktüberweisung sicher? Ja. Die Zahlung erfolgt ausschließlich über die gesicherte Online-Banking-Umgebung deiner Bank. MACHSPORT erhält keinen Zugriff auf deine Bank- oder Zugangsdaten. Fallen zusätzliche Gebühren an? Für die Nutzung der Direktüberweisung fallen keine zusätzlichen Gebühren an. Etwaige Kosten richten sich ausschließlich nach den Konditionen deiner Bank. Was passiert, wenn die Zahlung abbricht? Wird die Zahlung nicht erfolgreich abgeschlossen, erfolgt keine Belastung. Du kannst anschließend eine andere Zahlungsart auswählen.",
    "keywords": []
  },
  {
    "id": "kann-ich-eine-groessere-stueckzahl-oder-eine-b2b-bestellung-zum-beispiel-fuer-ein-unterneh",
    "category": "Zahlung & Bestellung",
    "question": "Kann ich eine größere Stückzahl oder eine B2B-Bestellung, zum Beispiel für ein Unternehmen, einen Verein oder eine Veranstaltung, bei machsport anfragen?",
    "answer": "Ja, selbstverständlich. Größere Bestellungen für Unternehmen, Vereine, Schulen, Veranstaltungen oder andere Organisationen sind bei machsport jederzeit möglich. Damit wir Verfügbarkeit, Lieferzeit, Preise und gegebenenfalls eine gewünschte Veredelung individuell für dich prüfen können, bitten wir dich, uns deine Anfrage direkt per E-Mail hier zu senden. Teile uns dabei am besten gleich mit: das gewünschte Produkt, die benötigte Stückzahl, gewünschte Größen, ob eine Veredelung (z. B. Logo, Name oder Nummer) gewünscht ist, sowie den gewünschten Liefertermin. Wir erstellen dir anschließend gerne ein individuelles Angebot und beraten dich bei der Umsetzung Deiner Bestellung.",
    "keywords": []
  },
  {
    "id": "wo-finde-ich-technische-unterlagen-formulare-logos-werbemittel-groessentabellen-oder-ander",
    "category": "Zahlung & Bestellung",
    "question": "Wo finde ich technische Unterlagen, Formulare, Logos, Werbemittel, Größentabellen oder andere Downloads?",
    "answer": "Weitere Informationen und verfügbare Unterlagen findest du in unseren beiden zentralen Informationsbereichen. In unserem Downloadbereich stellen wir unter anderem Logos, Werbebanner, Formulare und weitere Dokumente hier zur Verfügung. Die Größentabellen verschiedener Schuhhersteller findest du auf unserer Seite mit den Größentabellen hier . Solltest du die gesuchten technischen Unterlagen oder Informationen dort nicht finden, wende dich bitte direkt an unseren Kundenservice. Wir prüfen gerne, ob wir dir die benötigten Unterlagen zur Verfügung stellen können.",
    "keywords": []
  },
  {
    "id": "erstattet-machsport-mir-die-oesterreichische-oder-deutsche-mehrwertsteuer-wenn-ich-meine-b",
    "category": "Zahlung & Bestellung",
    "question": "Erstattet machsport mir die österreichische oder deutsche Mehrwertsteuer, wenn ich meine Bestellung in die Schweiz importiere und eine Import- bzw. Ausfuhrbestätigung vom Zoll vorlege?",
    "answer": "Nein, wir bieten keine nachträgliche Mehrwertsteuererstattung für Waren an, die in die Schweiz importiert werden. Auch wenn du vom Zoll eine entsprechende Import- oder Ausfuhrbestätigung erhältst, erstatten wir die beim Kauf verrechnete österreichische bzw. deutsche oder andere verrechnete Mehrwertsteuer nicht nachträglich zurück. Bitte berücksichtige dies bereits vor Deiner Bestellung.",
    "keywords": []
  },
  {
    "id": "wie-kann-ich-meine-lieferadresse-aendern",
    "category": "Versand",
    "question": "Wie kann ich meine Lieferadresse ändern?",
    "answer": "Du kannst deine Lieferadresse ändern, solange wir die Ware noch nicht versendet haben. Logge dich in deinem Kundenkonto ein. Unter \"Mein Konto\" Lieferadresse ändern und speichern. Zusätzlich kannst du auch alternative Lieferadressen (zB Arbeitsstelle) speichern.",
    "keywords": []
  },
  {
    "id": "warum-wird-meine-lieferadresse-nicht-erkannt",
    "category": "Versand",
    "question": "Warum wird meine Lieferadresse nicht erkannt?",
    "answer": "Falls du beim Checkout eine Fehlermeldung erhältst wie: „Adresse konnte nicht gefunden werden“ „Diese Adresse ist nicht gültig“ … dann liegt das häufig an technischen Einstellungen im Browser oder am Format der Adresse. Hier findest du eine Schritt-für-Schritt-Hilfe, um das Problem zu lösen: 1. Adresse richtig eingeben Straße und Hausnummer müssen in einem Feld stehen Richtig: Musterstraße 5 Falsch: Musterstraße in Zeile 1 und 5 in Zeile 2 Sonderzeichen (z. B. ß, Bindestriche, Umlaute) bitte normal eingeben, keine Abkürzungen oder kreative Schreibweisen. 2. Verwende einen aktuellen Browser Bitte verwende einen der folgenden aktuellsten Browser: Google Chrome Mozilla Fireforx Microsoft Edge Safari (macOS, iOS) Unsere Seite funktioniert am besten mit modernen Browsern wie Chrome, Firefox, Safari oder Edge. Der Internet Explorer wird von Shopify offiziell nicht mehr unterstützt – er funktioniert möglicherweise noch, aber wir empfehlen ihn nicht. 3. JavaScript aktivieren Unsere Website benötigt JavaScript, um Adressen korrekt zu verarbeiten. So überprüfst du, ob JavaScript aktiviert ist: Öffne diesen Test-Link. Hinweis : Dieser Link führt zu einer externen Seite, deren Barrierefreiheit wir nicht gewährleisten können. Bei Problemen kontaktiere uns gerne – wir helfen dir mit einer alternativen Lösung weiter. Folge der Anleitung für deinen Browser. 4. Inkognito-Modus oder anderer Browser hilft oft Wenn du dir unsicher bist, probiere es in einem anderen Browser oder im Inkognito-/Privatmodus. Du hast alles probiert und es klappt trotzdem nicht? Dann sende uns bitte einen Screenshot mit der Fehlermeldung. Deine vollständige Adresse (wie du sie eingegeben hast), welches Gerät und welchen Browser du verwendest. Du kannst uns gerne per Mail oder mittels Chat kontaktieren. Gerne helfen wir dir dann weiter.",
    "keywords": []
  },
  {
    "id": "kann-ich-bei-der-bestellung-eine-alternative-lieferadresse-angeben",
    "category": "Versand",
    "question": "Kann ich bei der Bestellung eine alternative Lieferadresse angeben?",
    "answer": "Du möchtest deine Bestellung an eine andere Adresse liefern lassen? Kein Problem! Im Checkout hast du die Möglichkeit, eine alternative Lieferadresse anzugeben. Egal, ob du das Paket ins Büro, zu Freunden oder an eine Abholstation senden möchtest – wir machen es dir einfach. Gib einfach die gewünschte Lieferadresse ein, und wir kümmern uns um den Rest. Flexibel, unkompliziert und ganz nach deinen Wünschen – so geht Versand bei machsport!",
    "keywords": []
  },
  {
    "id": "was-passiert-wenn-ich-zum-zeitpunkt-der-lieferung-nicht-zu-hause-bin",
    "category": "Versand",
    "question": "Was passiert, wenn ich zum Zeitpunkt der Lieferung nicht zu Hause bin?",
    "answer": "Wenn du generell unter Tags selten zu Hause bist, kannst du die Bestellung an eine abweichende Lieferadresse (zb Arbeitsstelle) liefern lassen. Wenn das Paket beim ersten Zustellversuch nicht zugestellt werden konnte, erfolgt ein weiterer Zustellversuch, oder du erhältst eine Benachrichtigung, dass dein Paket in der nächstgelegenen Abholstation hinterlegt wurde.",
    "keywords": []
  },
  {
    "id": "wie-lange-dauert-die-lieferung",
    "category": "Versand",
    "question": "Wie lange dauert die Lieferung?",
    "answer": "Bestellungen werden in der Regel werktags innerhalb von 24 Stunden bearbeitet und an dich versendet. Nachdem sie von unserem Lager versendet wurden, werden die Sendungen innerhalb von 1-2 Werktagen bei dir zugestellt. Sendungen nach Europa sind in der Regel nach 2-5 Werktagen, nachdem sie von unserem Lager weggeschickt wurden, zugestellt. Exklusive Vereinsartikel: Die Lieferzeiten werden direkt bei den Produkten angegeben.",
    "keywords": []
  },
  {
    "id": "was-tun-wenn-das-paket-nicht-zugestellt-wurde",
    "category": "Versand",
    "question": "Was tun, wenn das Paket nicht zugestellt wurde?",
    "answer": "Wenn ein Paket auch nach einer Woche nicht angekommen ist bzw. weder bei deinem Nachbarn, noch in einer Abholstation, hinterlegt wurde, dann setzte dich am besten umgehend mit uns in Verbindung. Wir prüfen umgehend den Verbleib deines Pakets und erteilen einen Nachforschungsauftrag bzw. erlassen eine Ersatzlieferung.",
    "keywords": []
  },
  {
    "id": "probleme-mit-der-lieferung",
    "category": "Versand",
    "question": "Probleme mit der Lieferung?",
    "answer": "Bitte wende dich umgehend an uns und wir kümmern uns um dein Problem. Email: office@moch-sport.shop Telefon: +43 7229 23880 (Mo-Mi 09:30-19:00, Do-Fr 09:30-21:00, Sa. 09:00-18:00)",
    "keywords": []
  },
  {
    "id": "welche-versandkosten-gibt-es",
    "category": "Versand",
    "question": "Welche Versandkosten gibt es?",
    "answer": "Alle Informationen zum Versand bekommst du hier . Vorsicht bei Abstellgenehmigung Solltest du dem Versanddienstleister eine Abstellgenehmigung erteilt haben achte bitte darauf, dass das Zustellrisiko beim Empfänger liegt. Das Zustellrisiko beginnt mit dem Zeitpunkt der Übergabe an den Empfänger, also mit dem Zeitpunkt, wo der Zusteller das Paket an den vereinbarten Ort hinterlegt. Dies bedeutet im Detail Verlust des Pakets : Sollte das Paket nach dem Abstellen gestohlen oder verloren gehen, haftet das Zustellunternehmen in der Regel nicht, da die Lieferung gemäß der Abstellgenehmigung als ordnungsgemäß zugestellt gilt. Beschädigung des Pakets : Wird das Paket durch äußere Einflüsse (z. B. Witterung, Tiere oder Vandalismus) beschädigt, übernimmt das Zustellunternehmen oft keine Verantwortung, da du die Abstellung auf eigenes Risiko erlaubt hast. Fehler beim Abstellort : Wenn das Paket an einer ungesicherten oder schlecht geeigneten Stelle abgestellt wird, liegt die Verantwortung häufig bei dir, da der Abstellort durch die Genehmigung freigegeben wurde.",
    "keywords": []
  },
  {
    "id": "mit-welchem-versanddienstleister-verschickt-machsport-meine-bestellung",
    "category": "Versand",
    "question": "Mit welchem Versanddienstleister verschickt machsport meine Bestellung?",
    "answer": "Wir versenden Bestellungen innerhalb Österreichs mit der Österreichischen Post. Für Lieferungen ins Ausland nutzen wir je nach Zielland die Deutsche Post bzw. DHL. Sobald wir deine Bestellung versendet haben, erhältst du eine Versandbestätigung mit den Informationen zur Sendungsverfolgung. So kannst du den Status deiner Lieferung jederzeit nachvollziehen.",
    "keywords": []
  },
  {
    "id": "kann-ich-meine-bestellung-an-eine-packstation-oder-paketstation-liefern-lassen",
    "category": "Versand",
    "question": "Kann ich meine Bestellung an eine Packstation oder Paketstation liefern lassen?",
    "answer": "Ja, du kannst bereits bei der Bestellung eine Packstation bzw. Paketstation als Lieferadresse angeben. Alternativ kannst du deine Sendung nach Erhalt der Versandbestätigung über die Sendungsverfolgung des jeweiligen Versanddienstleisters an eine Packstation oder Paketstation umleiten lassen, sofern diese Option für Deine Sendung verfügbar ist.",
    "keywords": []
  },
  {
    "id": "vorsicht-bei-abstellgenehmigung",
    "category": "Versand",
    "question": "Vorsicht bei Abstellgenehmigung!",
    "answer": "Solltest du dem Versanddienstleister eine Abstellgenehmigung erteilt haben achte bitte darauf, dass du dann das Zustellrisiko trägst. Das Zustellrisiko beginnt mit dem Zeitpunkt der Übergabe an den Empfänger, also mit dem Zeitpunkt, wo der Zusteller das Paket an den vereinbarten Ort hinterlegt. Dies bedeutet im Detail Verlust des Pakets : Sollte das Paket nach dem Abstellen gestohlen oder verloren gehen, haftet das Zustellunternehmen in der Regel nicht, da die Lieferung gemäß der Abstellgenehmigung als ordnungsgemäß zugestellt gilt. Beschädigung des Pakets : Wird das Paket durch äußere Einflüsse (z. B. Witterung, Tiere oder Vandalismus) beschädigt, übernimmt das Zustellunternehmen oft keine Verantwortung, da du die Abstellung auf eigenes Risiko erlaubt hast. Fehler beim Abstellort : Wenn das Paket an einer ungesicherten oder schlecht geeigneten Stelle abgestellt wird, liegt die Verantwortung häufig bei dir, da der Abstellort durch die Genehmigung freigegeben wurde.",
    "keywords": []
  },
  {
    "id": "warum-sich-dein-einkauf-bei-machsport-trotz-versandkosten-lohnt",
    "category": "Versand",
    "question": "Warum sich dein Einkauf bei machsport trotz Versandkosten lohnt?",
    "answer": "Bei machsport legen wir großen Wert auf Qualität – und das gilt nicht nur für unsere Produkte, sondern auch für unseren Versand. Hier sind die Gründe, warum sich dein Einkauf bei uns lohnt, auch wenn Versandkosten anfallen: Versicherter Versand für deine Sicherheit Deine Bestellung ist während des gesamten Transports versichert. Das bedeutet: Egal, ob etwas verloren geht oder beschädigt wird, wir sorgen dafür, dass du dein Paket sicher erhältst oder organisieren eine Ersatzlieferung. Unser Versandprozess folgt umweltschonenden Prinzipien Wir achten darauf, möglichst wenig Verpackungsmaterial einzusetzen und wo möglich auf recyclingfähige oder recycelte Materialien zurückzugreifen. Damit möchten wir einen kleinen Beitrag zu einem bewussteren Umgang mit Ressourcen leisten. Qualität und Service aus einer Hand Du kaufst bei machsport, weil du Wert auf hochwertige Produkte und kompetenten Service legst. Genau das bieten wir – von der Bestellung bis zur Zustellung. Keine versteckten Kosten Wir sind transparent: Du weißt von Anfang an, welche Kosten auf dich zukommen. Keine bösen Überraschungen, sondern ein fairer und ehrlicher Umgang mit dir. Mit deinem Einkauf bei machsport entscheidest du dich für Qualität, Sicherheit und umweltschonende Prinzipien zum Versand – und das ist jeden Cent wert! 💚",
    "keywords": []
  },
  {
    "id": "warum-werden-mir-versandkosten-angezeigt-obwohl-ich-ueber-79-euro-bestelle",
    "category": "Versand",
    "question": "Warum werden mir Versandkosten angezeigt, obwohl ich über 79 Euro bestelle?",
    "answer": "Grundsätzlich ist der Versand nach Österreich und Deutschland ab einem Bestellwert von € 79,00 Euro kostenlos. Eine Ausnahme gilt jedoch für Produkte aus dem Bereich „Mein Verein“, also veredelte Artikel aus Vereinskollektionen. Für diese Produkte fallen immer Versandkosten an – unabhängig vom Bestellwert. Der Grund dafür ist, dass diese Artikel bereits speziell produziert bzw. veredelt und meist stark reduziert sind. Daher ist hier kein kostenloser Versand mehr möglich. Sobald sich ein solcher Artikel im Warenkorb befindet, werden die Versandkosten automatisch korrekt angezeigt. Wenn Du unsicher bist, welche Produkte davon betroffen sind, hilft Dir unser Support gerne weiter.",
    "keywords": []
  },
  {
    "id": "koennen-bestellungen-zusammengefuehrt-versendet-werden",
    "category": "Versand",
    "question": "Können Bestellungen zusammengeführt versendet werden?",
    "answer": "Wenn du mehrere Bestellungen aufgegeben hast und diese gerne gemeinsam in einem Paket erhalten möchtest, schreib uns bitte so schnell wie möglich eine E-Mail mit deinen Bestellnummern. Solange der Bestellstatus noch nicht zu weit fortgeschritten ist, können wir prüfen, ob eine gemeinsame Bearbeitung oder Anpassung noch möglich ist. Ist eine Bestellung bereits verpackt oder wurde das Paket schon an den Versanddienstleister übergeben, können wir leider keine Änderung mehr vornehmen. Bitte beachte, dass eine Zusammenlegung von Bestellungen nicht garantiert werden kann und je nach Bearbeitungsstand eventuell zu Verzögerungen führen kann.",
    "keywords": []
  },
  {
    "id": "kann-ich-die-stores-in-linz-und-pasching-jederzeit-besuchen",
    "category": "Abholung & Filialen",
    "question": "Kann ich die Stores in Linz und Pasching jederzeit besuchen?",
    "answer": "Ja. Wir sind gerne zu den Öffnungszeiten für dich da. Diese findest du ganz unten auf der Seite und im Impressum.",
    "keywords": []
  },
  {
    "id": "wann-kann-ich-meine-onlinebestellung-abholen",
    "category": "Abholung & Filialen",
    "question": "Wann kann ich meine Onlinebestellung abholen?",
    "answer": "Nachdem du eine Onlinebestellung getätigt hast, kannst du diese in der Regel werktags binnen 1h abholen. Die Ware ist abholbereit, sobald du von uns eine Benachrichtigung erhalten hast. Bitte warte die Benachrichtigung ab, bevor du die Ware abholen kommst. Tipp: Die Filiale in Linz ist spezialisiert auf Laufsport und beherbergt zudem den Fanshop des FC Blau-Weiß Linz. Die Hauptfiliale in Pasching ist umfassend ausgestattet und bietet unser vollständiges Sortiment. Produkte der Marken Salta und Powershot sind nicht in den Filialen ausgestellt. Unser Tipp: Wenn du sicherstellen möchtest, ob ein bestimmter Artikel vor Ort verfügbar ist, empfehlen wir, vorab telefonisch in der gewünschten Filiale nachzufragen.",
    "keywords": []
  },
  {
    "id": "sind-alle-im-onlineshop-ersichtlichen-produkte-auch-in-den-filialen-vorraetig",
    "category": "Abholung & Filialen",
    "question": "Sind alle im Onlineshop ersichtlichen Produkte auch in den Filialen vorrätig?",
    "answer": "In der Regel ja – die im Onlineshop als „lagernd“ angezeigten Produkte befinden sich auf Lager und sind in unseren Filialen in Linz und Pasching verfügbar. Bitte beachte jedoch: Die Lagerstände im Onlineshop spiegeln den Gesamtbestand unseres Unternehmens wider. Das bedeutet, dass nicht jedes Produkt automatisch in jeder Filiale verfügbar ist. Die Filiale in Linz ist spezialisiert auf Laufsport und beherbergt zudem den Fanshop des FC Blau-Weiß Linz. Die Hauptfiliale in Pasching ist umfassend ausgestattet und bietet unser vollständiges Sortiment. Produkte der Marken Salta und Powershot sind nicht in den Filialen ausgestellt. Unser Tipp: Wenn du sicherstellen möchtest, ob ein bestimmter Artikel vor Ort verfügbar ist, empfehlen wir, vorab telefonisch in der gewünschten Filiale nachzufragen.",
    "keywords": []
  },
  {
    "id": "warum-zeigt-mir-die-shop-app-an-dass-meine-bestellung-schon-abholbereit-oder-versendet-wur",
    "category": "Abholung & Filialen",
    "question": "Warum zeigt mir die „Shop“-App an, dass meine Bestellung schon abholbereit oder versendet wurde?",
    "answer": "Die Shop-App ist eine Tracking-App von Shopify, die Bestellungen automatisch anzeigt, wenn du mit deiner E-Mail-Adresse eingeloggt bist. Bei Abholung im Store („Click & Collect“), Teilretournierungen oder Bestellanpassungen kann es passieren, dass die App einen falschen Status anzeigt – zum Beispiel „abholbereit“ oder „versendet“, obwohl wir deine Bestellung gerade erst vorbereiten. Das liegt daran, dass die App manche Informationen automatisch interpretiert und keinen eigenen Zwischenstatus wie „in Bearbeitung“ kennt. Dies liegt nicht in unserem Einflussbereich, da es sich dabei um eine eigene APP von Shopify handelt. 👉 Wichtig für dich: Maßgeblich sind immer unsere eigenen Mailbenachrichtigungen von machsport und nicht jene von der Shop-App. Bitte ignoriere daher eventuelle Statusanzeigen in der Shop-App – sie können bei Click & Collect leider ungenau sein.",
    "keywords": []
  },
  {
    "id": "wie-lange-dauert-die-veredelung-eines-produktes-bedruckung-bestickung",
    "category": "Bedruckung & Bestickung",
    "question": "Wie lange dauert die Veredelung eines Produktes? (Bedruckung, Bestickung)",
    "answer": "Kaufst du dir ein Produkt in unserer Filiale oder nimmst ein vorhandenes Produkt mit, können wir es veredeln. Das Bedrucken dauert bis zu 60 Minuten, geht in der Regel aber schneller. Das Besticken eines Produktes dauert 3-5 Werktage.",
    "keywords": []
  },
  {
    "id": "was-kostet-die-bedruckung",
    "category": "Bedruckung & Bestickung",
    "question": "Was kostet die Bedruckung?",
    "answer": "Produkte können auch direkt in unserer Filiale, in der Plus-City in Pasching, bedruckt werden. Du hast das zu bedruckende Produkt bei machsport gekauft? Nummer und Name: € 15,- Nur Nummer: € 10,- Nur Name: € 10,- Du hast das Produkt nicht bei uns gekauft? Nummer und Name: € 20,- Nur Nummer: € 15€ ,- Nur Name: € 15,- Die Bedruckung dauert bis zu 60 Minuten, geht in der Regel aber schneller.",
    "keywords": []
  },
  {
    "id": "was-kostet-die-bestickung",
    "category": "Bedruckung & Bestickung",
    "question": "Was kostet die Bestickung?",
    "answer": "Wir besticken Schuhe, Kappen und Schirmmützen, Handtücher, Baumwollprodukte, Leder- und Filzprodukte. Du kannst dein Produkt gerne selbst mitnehmen oder bei uns kaufen. Name oder Logo: € 10,-",
    "keywords": []
  },
  {
    "id": "wie-lange-dauert-die-bestickung",
    "category": "Bedruckung & Bestickung",
    "question": "Wie lange dauert die Bestickung?",
    "answer": "Produkte können auch direkt in unserer Filiale, in der Plus-City in Pasching, bestickt werden. Du hast das zu bestickende Produkt bei machsport gekauft? Nummer und Name: € 15,- Nur Nummer: € 10,- Nur Name: € 10,- Du hast das Produkt nicht bei uns gekauft? Nummer und Name: € 20,- Nur Nummer: € 15€ ,- Nur Name: € 15,- Die Bedruckung dauert bis zu 60 Minuten, geht in der Regel aber schneller.",
    "keywords": []
  },
  {
    "id": "was-kann-bestickt-werden",
    "category": "Bedruckung & Bestickung",
    "question": "Was kann bestickt werden?",
    "answer": "Wir können folgende Produkte besticken, ganz gleich ob du diese bei uns gekauft hast oder nicht: Schuhe Kappen und Schirmmützen Handtücher Baumwollprodukte Lederprodukte Filzprodukte",
    "keywords": []
  },
  {
    "id": "was-kann-nicht-bestickt-werden",
    "category": "Bedruckung & Bestickung",
    "question": "Was kann nicht bestickt werden?",
    "answer": "Manche Textilien und Materialien können nicht bestickt werden, da hier u.a. das Material selbst oder die Materialeigenschaft beschädigt werden würde: Funktionskleidung wie Regenjacken oder elastische Textilien",
    "keywords": []
  },
  {
    "id": "kann-ich-auch-produkte-bedrucken-besticken-lassen-die-nicht-bei-machsport-gekauft-wurden",
    "category": "Bedruckung & Bestickung",
    "question": "Kann ich auch Produkte bedrucken/besticken lassen, die nicht bei machsport gekauft wurden?",
    "answer": "Ja. Wir veredeln dir dein Produkt auch dann, wenn du es nicht bei uns gekauft hast.",
    "keywords": []
  },
  {
    "id": "in-welchen-dateiformaten-kann-ich-machsport-die-logos-senden",
    "category": "Bedruckung & Bestickung",
    "question": "In welchen Dateiformaten kann ich machsport die Logos senden?",
    "answer": "Bitte sende uns Logos in eines der angeführten Formate. svg eps ai pdf Du kannst die Logos direkt an unsere Grafikabteilung senden, per Mail .",
    "keywords": []
  },
  {
    "id": "gibt-es-auch-beflockung-von-textilien",
    "category": "Bedruckung & Bestickung",
    "question": "Gibt es auch Beflockung von Textilien?",
    "answer": "Nein, eine klassische Beflockung bieten wir bei machsport nicht mehr an. Diese Technik wird heute nur noch selten eingesetzt, da es mittlerweile modernere und deutlich langlebigere Veredelungsverfahren gibt. Wir setzen stattdessen auf hochwertige Drucklösungen sowie Stick. Diese Varianten sind robuster, langlebiger und bieten in der Regel ein besseres Ergebnis – sowohl optisch als auch in der Nutzung.",
    "keywords": []
  },
  {
    "id": "wird-die-beflockung-bei-nationalteam-oder-vereinstrikots-exakt-wie-beim-original-umgesetzt",
    "category": "Bedruckung & Bestickung",
    "question": "Wird die Beflockung bei Nationalteam- oder Vereinstrikots exakt wie beim Original umgesetzt?",
    "answer": "Wir setzen die Veredelung möglichst originalgetreu und zulässig um. Name, Nummer, Schriftbild und Positionierung orientieren sich so gut wie möglich am jeweiligen Trikotdesign. Bitte beachte aber: Wir sind nicht lizenzberechtigt, Club- oder Nationenlogos innerhalb der Rückennummern mitzuveredeln. Deshalb kann die Beflockung optisch zur offiziellen Match- oder Fanshop-Beflockung passen, aber nicht in jedem Detail exakt identisch sein.",
    "keywords": []
  },
  {
    "id": "kann-ich-bei-einem-vereinsprodukt-einen-zusaetzlichen-aufdruck-eine-weitere-nummer-oder-ei",
    "category": "Bedruckung & Bestickung",
    "question": "Kann ich bei einem Vereinsprodukt einen zusätzlichen Aufdruck, eine weitere Nummer oder einen zusätzlichen Namen ergänzen lassen?",
    "answer": "Bei Vereinsprodukten sind grundsätzlich nur die Veredelungen möglich, die direkt auf der jeweiligen Produktseite angeboten werden. Ein zusätzlicher Aufdruck, der über die online auswählbaren Optionen hinausgeht, gehört nicht zum Standardangebot und kann daher nicht direkt über den Onlineshop bestellt werden. Ob eine individuelle Zusatzveredelung möglich ist, prüfen wir gerne im Einzelfall. Bitte sende uns dazu eine Anfrage mit den gewünschten Informationen an hier . Wir klären anschließend, ob die gewünschte Umsetzung technisch möglich ist und informieren Dich über die entsprechenden Kosten und die Bearbeitungszeit.",
    "keywords": []
  },
  {
    "id": "wie-kann-ich-ein-produkt-retour-senden-und-erstattet-bekommen",
    "category": "Umtausch, Retouren & Reklamationen",
    "question": "Wie kann ich ein Produkt retour senden und erstattet bekommen?",
    "answer": "Für Kunden aus Österreich & Deutschland Wenn dir ein Artikel nicht gefällt, dann besuch uns in einem machsport Store oder sende das Produkt innerhalb von 14 Tagen, ab Erhalt der Ware, an unser zurück. Für Kunden aus Österreich und Deutschland bieten wir einen kostenlosen Rückversand an. Kunden aus Österreich bekommen das kostenlose Rücksendelabel hier . Kunden aus Deutschland bekommen das kostenlose Rücksendelabel hier . Hinweis : Dieser Link führt zu einer externen Seite, deren Barrierefreiheit wir nicht gewährleisten können. Bei Problemen kontaktiere uns gerne – wir helfen dir mit einer alternativen Lösung weiter. Für Kunden aus allen weiteren Ländern Wenn du aus einem anderem Land Ware an uns retour senden möchtest, ist das natürlich auch, binnen 14 Tagen ab Erhalt der Ware, kein Problem. Wähle einen Versandpartner deiner Wahl und sende das Paket an die hier unten angeführte Adresse zurück. Die Rücksendekosten sind selber zu entrichten. MACHSPORT GmbH Pluskaufstraße 7 Returns department 4061 Pasching Austria Allgemeine Informationen Unsere Mitarbeiter kümmern sich, nach Erhalt der Rücksendung, innerhalb von 5 Werktagen um die Bearbeitung. Wir informieren dich dabei über den Status der Bearbeitung. Bitte beachte unser 14-tägiges Rückgaberecht, welches mit Erhalt der Ware beginnt. Die Kosten für die Rücksendung werden, für Kunden aus Österreich und Deutschland, von uns übernommen. Für alle weiteren Länder sind die Rücksendekosten eigenständig zu tragen. Unsere Mitarbeiter kümmern sich innerhalb von 5 Werktagen um deine Retoure und informieren dich über den Status. Alle Informationen zum Umtausch und Rückversand bekommst du hier .",
    "keywords": []
  },
  {
    "id": "kann-ich-ein-online-gekauftes-produkt-auch-in-einer-filiale-zurueckgeben",
    "category": "Umtausch, Retouren & Reklamationen",
    "question": "Kann ich ein online gekauftes Produkt auch in einer Filiale zurückgeben?",
    "answer": "Ja. Kein Problem. Du kannst dein online erworbenes Produkt auch gerne direkt in der Filiale zurückgeben.",
    "keywords": []
  },
  {
    "id": "wie-kann-ich-ein-produkt-umtauschen",
    "category": "Umtausch, Retouren & Reklamationen",
    "question": "Wie kann ich ein Produkt umtauschen?",
    "answer": "Wenn du ein Produkt umtauschen möchtest, wende dich bitte mit deinem Anliegen an unsere Mitarbeiter unter office@moch-sport.shop , Bei einem Umtausch regeln wir alles für dich und du musst nicht selbst eine weitere Bestellung aufgeben. Von der Rückgabe und Umtausch ausgeschlossen sind veredelte Produkte. Also Produkte die von uns für dich bedruckt oder gestickt wurden. Die Gewährleistungsansprüche bleiben vollumfänglich aufrecht.",
    "keywords": []
  },
  {
    "id": "welche-produkte-sind-vom-rueckgaberecht-ausgeschlossen",
    "category": "Umtausch, Retouren & Reklamationen",
    "question": "Welche Produkte sind vom Rückgaberecht ausgeschlossen?",
    "answer": "Von der Rückgabe und Umtausch ausgeschlossen sind veredelte Produkte. Also Produkte die von uns für dich bedruckt oder gestickt wurden. Die Gewährleistungsansprüche bleiben vollumfänglich aufrecht.",
    "keywords": []
  },
  {
    "id": "wann-sind-wir-zum-ruecktritt-von-der-bestellung-berechtigt",
    "category": "Umtausch, Retouren & Reklamationen",
    "question": "Wann sind wir zum Rücktritt von der Bestellung berechtigt?",
    "answer": "machsport verpflichten sich, deine Bestellung zu den Bedingungen der Website anzunehmen. Falls Rechen-, Druck oder Schreibfehler auf der Website auftreten sind wir zum Rücktritt berechtigt. Alle unsere Angebote sind gültig solange der Vorrat reicht. Wenn ein Lieferant trotz vertraglicher Verpflichtung die bestellte Ware nicht liefert, sind wir ebenfalls zum Rücktritt berechtigt. In diesem Fall wirst du unverzüglich von unseren Mitarbeitern darüber informiert, dass das bestellte Produkt nicht zur Verfügung steht. Der bereits bezahlte Kaufpreis wird unverzüglich erstattet.",
    "keywords": []
  },
  {
    "id": "passformgarantie-fuer-schuhe",
    "category": "Umtausch, Retouren & Reklamationen",
    "question": "Passformgarantie für Schuhe!",
    "answer": "Wir bieten dir eine Passformgarantie an. Du kannst innerhalb von 14 Tagen deine bei machsport gekauften Schuhe wieder retour bringen, wenn sie doch irgendwo drücken sollten oder dir einfach nicht passen. Die Passformgarantie gilt für alle Schuhe. Dabei ist es egal, ob du die Schuhe zuhause, auf der Straße oder am Laufband getestet hast. Wichtig ist, dass sich die Schuhe in sauberem und unbeschädigtem Zustand befinden. Wurden die Schuhe nur getestet und befinden sie sich weiterhin in neuwertigem Zustand, erfolgt eine Rückerstattung. Sollten Gebrauchsspuren vorhanden sein, kann eine anteilige Rückerstattung mit Abschlag erfolgen. Diese wird gemeinsam mit dir abgestimmt.",
    "keywords": []
  },
  {
    "id": "garmin-reparaturservice",
    "category": "Umtausch, Retouren & Reklamationen",
    "question": "Garmin Reparaturservice!",
    "answer": "Du hast ein Produkt von Garmin und irgendwas funktioniert nicht? Kein Problem, denn wir helfen dir weiter. Du kannst entweder direkt in eines unserer Filialen kommen, oder du setzt dich direkt mit Garmin in Verbindung. Garmin bietet ein ebenso kundenorientiertes Direktservice an wie machsport. Besuche uns in der Filiale Zum Garmin-Direktservice Hinweis : Dieser Link führt zu einer externen Seite, deren Barrierefreiheit wir nicht gewährleisten können. Bei Problemen kontaktiere uns gerne – wir helfen dir mit einer alternativen Lösung weiter.",
    "keywords": []
  },
  {
    "id": "gewaehrleistung",
    "category": "Umtausch, Retouren & Reklamationen",
    "question": "Gewährleistung",
    "answer": "Bei uns bekommst du nicht nur starke Produkte, sondern auch starke Rechte – versprochen! Sollte bei deinem bestellten Artikel doch einmal etwas nicht passen oder ein Mangel auftreten, greift die gesetzliche Gewährleistung Was bedeutet das für dich? Du hast als Verbraucher*in grundsätzlich 24 Monate Gewährleistung ab Erhalt der Ware. Innerhalb dieser Zeit sorgen wir dafür, dass du ein einwandfreies Produkt in den Händen hältst. Wenn ein Artikel mangelhaft ist – also z. B. ein Herstellungsfehler vorliegt oder der Artikel nicht wie beschrieben funktioniert – hast du das Recht auf Nachbesserung oder Ersatz . Das bedeutet: Wir reparieren den Artikel oder schicken dir ein neues Exemplar. Und falls das nicht klappt? Sollte die Reparatur scheitern oder aus anderen Gründen nicht möglich oder zumutbar sein, kannst du entweder: neues Produkt verlangen, Kaufpreis mindern, oder Kaufvertrag zurücktreten (d. h. du gibst den Artikel zurück und bekommst dein Geld erstattet). Wichtig: Die Gewährleistung deckt Material- oder Herstellungsfehler ab, nicht aber normale Abnutzung oder Schäden durch unsachgemäßen Gebrauch. Wenn du den Verdacht hast, dass ein Produkt einen Mangel hat, melde dich einfach bei uns. Wir kümmern uns schnell und unkompliziert darum!",
    "keywords": []
  },
  {
    "id": "warum-darf-ich-batterien-nicht-im-hausmuell-entsorgen",
    "category": "Altbatterie-Rückgabe & -Entsorgung",
    "question": "Warum darf ich Batterien nicht im Hausmüll entsorgen?",
    "answer": "Batterien enthalten Schwermetalle wie Quecksilber, Blei oder Cadmium. Diese können bei unsachgemäßer Entsorgung Boden, Wasser und Gesundheit gefährden. Deshalb ist es gesetzlich verboten, Batterien im Restmüll zu entsorgen. Bitte gib sie fachgerecht zurück – zum Beispiel bei uns.",
    "keywords": []
  },
  {
    "id": "welche-batterien-kann-ich-bei-machsport-zurueckgeben",
    "category": "Altbatterie-Rückgabe & -Entsorgung",
    "question": "Welche Batterien kann ich bei machsport zurückgeben?",
    "answer": "Du kannst bei uns alle haushaltsüblichen Batterien und Akkus kostenlos zurückgeben, z. B.: Knopfzellen Lithium-Ionen-Akkus (z.B. aus Sportuhren) AA-, AAA-, C-, D-Batterien Akkus aus GPS- oder Fitnessgeräten Nicht angenommen werden Autobatterien oder Industriebatterien.",
    "keywords": []
  },
  {
    "id": "muss-ich-die-batterie-bei-machsport-gekauft-haben",
    "category": "Altbatterie-Rückgabe & -Entsorgung",
    "question": "Muss ich die Batterie bei machsport gekauft haben?",
    "answer": "Nein. Du darfst bei uns auch Batterien zurückgeben, die du nicht bei machsport gekauft hast – solange es sich um haushaltsübliche Batterien handelt.",
    "keywords": []
  },
  {
    "id": "wie-kann-ich-meine-altbatterien-zuruecksenden",
    "category": "Altbatterie-Rückgabe & -Entsorgung",
    "question": "Wie kann ich meine Altbatterien zurücksenden?",
    "answer": "Ganz einfach per Post! Die Kosten für die Rücksendung hast du zu übernehmen. Bitte beachte: Batteriepole gegen Kurzschluss sichern (z.B. mit Klebeband abkleben) Gut verpacken, idealerweise in Karton oder Luftpolstertasche",
    "keywords": []
  },
  {
    "id": "kann-ich-batterien-auch-direkt-in-den-filialen-bei-machsport-abgeben",
    "category": "Altbatterie-Rückgabe & -Entsorgung",
    "question": "Kann ich Batterien auch direkt in den Filialen bei machsport abgeben?",
    "answer": "Ja, sehr gerne! Du kannst Altbatterien in allen unseren Filialen kostenlos abgeben. Alternativ kannst du sie auch zu einer kommunalen Sammelstelle in deiner Nähe bringen.",
    "keywords": []
  },
  {
    "id": "wo-finde-ich-das-symbol-fuer-batterieentsorgung",
    "category": "Altbatterie-Rückgabe & -Entsorgung",
    "question": "Wo finde ich das Symbol für Batterieentsorgung?",
    "answer": "Alle Batterien sind mit dem Symbol einer durchgestrichenen Mülltonne gekennzeichnet. Es zeigt dir, dass du die Batterie nicht über den Hausmüll entsorgen darfst.",
    "keywords": []
  },
  {
    "id": "wie-unterstuetzt-machsport-den-umweltschutz",
    "category": "Altbatterie-Rückgabe & -Entsorgung",
    "question": "Wie unterstützt machsport den Umweltschutz?",
    "answer": "Wir nehmen Batterien nicht nur zurück, sondern informieren aktiv über Rückgabemöglichkeiten. So helfen wir dir, die Umwelt zu schützen und gesetzliche Vorgaben einzuhalten. Gemeinsam leisten wir einen Beitrag für eine nachhaltigere Zukunft.",
    "keywords": []
  },
  {
    "id": "kann-ich-auch-waschmaschinen-und-andere-grosse-geraete-zurueckgeben",
    "category": "Altbatterie-Rückgabe & -Entsorgung",
    "question": "Kann ich auch Waschmaschinen und andere große Geräte zurückgeben?",
    "answer": "Wir verkaufen ausschließlich kleine Elektrogeräte wie Sportuhren, GPS-Geräte und Fitness-Tracker. Nach dem Elektro- und Elektronikgerätegesetz sind Händler nur zur Rücknahme solcher Altgeräte verpflichtet, die zur gleichen Geräteart gehören wie die von ihnen angebotenen Produkte. Großgeräte wie Waschmaschinen oder Kühlschränke gehören nicht zu unserem Sortiment und können daher nicht von uns zurückgenommen werden. Diese Geräte kannst du bei den zuständigen kommunalen Sammelstellen entsorgen.",
    "keywords": []
  },
  {
    "id": "welche-elektrogeraete-kann-ich-retour-geben",
    "category": "Altbatterie-Rückgabe & -Entsorgung",
    "question": "Welche Elektrogeräte kann ich retour geben?",
    "answer": "Wir sind nur zur Rücknahme von Altgeräten verpflichtet, die der gleichen Geräteart wie unsere Produkte entsprechen. Großgeräte wie Waschmaschinen, Kühlschränke, Fernseher, Lampen oder andere Großgeräte nehmen wir daher nicht zurück",
    "keywords": []
  },
  {
    "id": "wo-kann-ich-mich-zum-newsletter-anmelden-und-erhalte-einen-willkommensgutschein",
    "category": "Newesletter & Gewinnspiele",
    "question": "Wo kann ich mich zum Newsletter anmelden und erhalte einen Willkommensgutschein?",
    "answer": "Melde dich zum Newsletter an. Nachdem du deine Mailadresse eingetragen und bestätigt hast, bekommst du automatisch eine Mail mit deinem Gutscheincode. Gegebenenfalls prüfe bitte auch deinen Spam-Ordner. Melde dich hier zum Newsletter an. Hinweis : Dieser Link führt zu einer externen Seite, deren Barrierefreiheit wir nicht gewährleisten können. Bei Problemen kontaktiere uns gerne – wir helfen dir mit einer alternativen Lösung weiter.",
    "keywords": []
  },
  {
    "id": "wie-kann-ich-mich-vom-newsletter-abmelden",
    "category": "Newesletter & Gewinnspiele",
    "question": "Wie kann ich mich vom Newsletter abmelden?",
    "answer": "Du möchtest dich abmelden? Das würden wir sehr schade finden. Aber natürlich kannst du dich jederzeit vom Newsletter abmelden. Melde dich hier vom Newsletter ab. Hinweis : Dieser Link führt zu einer externen Seite, deren Barrierefreiheit wir nicht gewährleisten können. Bei Problemen kontaktiere uns gerne – wir helfen dir mit einer alternativen Lösung weiter.",
    "keywords": []
  },
  {
    "id": "kann-ich-den-newsletter-willkommensgutschein-auch-direkt-in-den-filialen-einloesen-2",
    "category": "Newesletter & Gewinnspiele",
    "question": "Kann ich den Newsletter Willkommensgutschein auch direkt in den Filialen einlösen?",
    "answer": "Nein. Der Willkommensgutschein für den Newsletter ist ausschließlich in unserem Onlineshop einzulösen. Wir haben online und stationär die gleichen Preise. Du kannst dir die Ware zusenden lassen, oder nach Bestellung auch gerne in unserer Filiale abholen (Click&Collect).",
    "keywords": []
  },
  {
    "id": "wie-kann-ich-einen-kostenlosen-termin-vereinbaren",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Wie kann ich einen kostenlosen Termin vereinbaren?",
    "answer": "Um einen Termin für eine kostenlose Laufstilanalyse zu vereinbaren, klicke bitte hier .",
    "keywords": []
  },
  {
    "id": "ist-die-laufstilanalyse-komplett-kostenlos",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Ist die Laufstilanalyse komplett kostenlos?",
    "answer": "Ja. Es entstehen dir keinerlei Kosten. Die Terminbuchung, als auch die Analyse selbst, sind kostenlos und unverbindlich.",
    "keywords": []
  },
  {
    "id": "wo-wird-die-laufstilanalyse-durchgefuehrt",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Wo wird die Laufstilanalyse durchgeführt?",
    "answer": "Es gibt 2 Möglichkeiten. Wir bieten die Laufstilanalyse in unserem Store in der Plus-City (Pasching) an, sowie auch online. Für mehr Informationen klicke hier .",
    "keywords": []
  },
  {
    "id": "kann-ich-auch-ohne-vorhergehende-anmeldung-eine-laufstilanalyse-machen",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Kann ich auch ohne vorhergehende Anmeldung eine Laufstilanalyse machen?",
    "answer": "Ja. Komme bitte einfach in unsere Filiale, in der Plus-City, in Pasching. Wir freuen uns auf dein Kommen und du bekommst natürlich auch ohne Anmeldung eine kostenlose Laufstilanalyse.",
    "keywords": []
  },
  {
    "id": "was-genau-ist-die-currex-fussanalyse",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Was genau ist die CURREX-Fußanalyse?",
    "answer": "Die CURREX-Fußanalyse ist eine professionelle Methode, um deinen Fußtyp, dein Abrollverhalten und deine Bewegungsmuster zu analysieren. Mit moderner Technik ermitteln wir, welcher Schuh optimal zu dir passt – individuell abgestimmt auf deine Bedürfnisse.",
    "keywords": []
  },
  {
    "id": "wie-lange-dauert-die-fussanalyse",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Wie lange dauert die Fußanalyse?",
    "answer": "Die Analyse dauert in der Regel nur 10 bis 15 Minuten. Wir nehmen uns die Zeit, dir alles genau zu erklären und dir eine passende Empfehlung zu geben.",
    "keywords": []
  },
  {
    "id": "ist-die-analyse-wirklich-kostenlos",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Ist die Analyse wirklich kostenlos?",
    "answer": "Ja, die Fußanalyse ist für dich komplett kostenlos. Du kannst ohne Verpflichtung vorbeikommen und dir ein klares Bild davon machen, welcher Schuh zu dir passt.",
    "keywords": []
  },
  {
    "id": "brauche-ich-einen-termin-fuer-die-fussanalyse",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Brauche ich einen Termin für die Fußanalyse?",
    "answer": "Nein, ein Termin ist nicht unbedingt erforderlich. Du kannst spontan vorbeikommen. Wenn du sicher gehen möchtest, dass keine Wartezeit entsteht, empfehlen wir dir, einen Termin zu vereinbaren.",
    "keywords": []
  },
  {
    "id": "wie-kann-ich-einen-kostenlosen-termin-vereinbaren-2",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Wie kann ich einen kostenlosen Termin vereinbaren?",
    "answer": "Um einen Termin für eine kostenlose Fußanalyse zu vereinbaren, klicke bitte hier .",
    "keywords": []
  },
  {
    "id": "kann-ich-die-analyse-auch-fuer-fussballschuhe-machen",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Kann ich die Analyse auch für Fußballschuhe machen?",
    "answer": "Ja, die CURREX-Fußanalyse ist nicht nur für Laufschuhe geeignet, sondern auch für Fußballschuhe. Egal, welchen Sport du ausübst – wir finden das passende Modell für dich.",
    "keywords": []
  },
  {
    "id": "kann-ich-nach-der-analyse-direkt-schuhe-kaufen",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Kann ich nach der Analyse direkt Schuhe kaufen?",
    "answer": "Natürlich! Nach der Analyse zeigen wir dir genau, welche Modelle am besten zu dir passen. Du kannst die Schuhe direkt vor Ort anprobieren und auf Wunsch kaufen.",
    "keywords": []
  },
  {
    "id": "ist-diese-faq-ohne-javascript-nutzbar",
    "category": "Laufstilanalyse & Fußanalyse",
    "question": "Ist diese FAQ ohne JavaScript nutzbar?",
    "answer": "Ja. Die Fragen werden mit nativen HTML Elementen umgesetzt und funktionieren auch ohne zusätzliches Script.",
    "keywords": []
  },
  {
    "id": "wir-bespannen-auch-tennisschlaeger",
    "category": "Tennisschläger Bespannservice",
    "question": "Wir bespannen auch Tennisschläger!",
    "answer": "In der Filiale Plus-City, in Pasching, bespannen wir deinen Tennisschläger. Du kannst einen Termin online buchen oder du kommst direkt in die Filiale Plus-City. Bei der Bespannung deines Tennisschlägers gehen wir auf deine individuellen Bedürfnisse ein.",
    "keywords": []
  },
  {
    "id": "was-kostet-der-bespannservice-von-tennisschlaegern",
    "category": "Tennisschläger Bespannservice",
    "question": "Was kostet der Bespannservice von Tennisschlägern?",
    "answer": "Wenn du dir eine Saite bei machsport kaufst, bespannen wir dir deinen Tennisschläger für € 12,-, ansonsten verrechnen wir € 15,-.. Der Bespannservice ist nur in der Filiale Plus-City, in Pasching, möglich.",
    "keywords": []
  },
  {
    "id": "wer-kann-vereinsprodukt-kaufen",
    "category": "Vereinsbestellungen",
    "question": "Wer kann Vereinsprodukt kaufen?",
    "answer": "Wir produzieren unter anderem für Vereine eigene Vereinskollektionen. Diese Vereinskollektionen stehen den Mitgliedern des betreffenden Vereins zur Verfügung und kann ganz einfach über den Webshop von machsport bestellt werden.",
    "keywords": []
  },
  {
    "id": "wie-setzt-sich-der-preis-des-vereinsproduktes-zusammen",
    "category": "Vereinsbestellungen",
    "question": "Wie setzt sich der Preis des Vereinsproduktes zusammen?",
    "answer": "Der Preis eines Vereinsprodukts ergibt sich aus dem Produktpreis zzgl. Druckkosten für zum Beispiel Logo, Eigenname, Initialen etc. Der Vereinsrabatt ist beim Preis bereits berücksichtigt. Fair Play: Auf Vereinsprodukte gibt’s schon starke Rabatte – deshalb sind sie vom Gratisversand ausgenommen .",
    "keywords": []
  },
  {
    "id": "wo-kann-ich-die-kundennummer-meiner-machsport-teamkarte-eintragen",
    "category": "Vereinsbestellungen",
    "question": "Wo kann ich die Kundennummer meiner machsport-Teamkarte eintragen?",
    "answer": "Die Kundennummer deiner machsport-Teamkarte kannst du im Checkout im Feld für Rabatt- oder Gutscheincodes eintragen. Der Code befindet sich auf der Rückseite deiner Teamkarte und wird dort automatisch geprüft. Die Teamkarte kann damit auch online im machsport Onlineshop verwendet werden. Weitere Informationen zur Nutzung findest du auf unserer Seite zur machsport Teamkarte und zum Vereinsrabatt.",
    "keywords": []
  },
  {
    "id": "welche-lieferzeiten-hat-ein-produkt-aus-der-vereinskollektion",
    "category": "Vereinsbestellungen",
    "question": "Welche Lieferzeiten hat ein Produkt aus der Vereinskollektion?",
    "answer": "Die Lieferzeiten variieren je nach Hersteller. Hier geben wir einen Überblick über die zu erwartende Lieferzeit ab Bestelldatum: Erima: 7 - 14 Werktage Jako: 7 - 14 Werktage Nike: 20 - 30 Werktage Uhlsport: 7 - 14 Werktage Kempa: 7 - 14 Werktage Puma: 7 - 18 Werktage Bei Abweichungen halten wir dich natürlich laufend informiert. Die genauen Lieferzeitangaben findest du direkt bei den Produkten.",
    "keywords": []
  },
  {
    "id": "kann-ich-eine-vereinsbestellung-sofort-bedrucken-lassen-und-abholen",
    "category": "Vereinsbestellungen",
    "question": "Kann ich eine Vereinsbestellung sofort bedrucken lassen und abholen?",
    "answer": "Nein. Es ist leider nicht möglich, dass du im Onlineshop etwas aus einer Vereinskollektion, deines Vereins, bestellst und diese sofort bedrucken lässt bzw. abholen kannst. Bitte beachte die Hersteller bezogenen Lieferzeiten \"Welche Lieferzeiten hat ein Produkt aus der Vereinskollektion?\"",
    "keywords": []
  },
  {
    "id": "kann-ich-eine-vereinsbestellung-sofort-bedrucken-lassen-und-abholen-2",
    "category": "Vereinsbestellungen",
    "question": "Kann ich eine Vereinsbestellung sofort bedrucken lassen und abholen?",
    "answer": "Nein. Es ist leider nicht möglich, dass du im Onlineshop etwas aus einer Vereinskollektion, deines Vereins, bestellst und diese sofort bedrucken lässt bzw. abholen kannst. Bitte beachte die Hersteller bezogenen Lieferzeiten \"Welche Lieferzeiten hat ein Produkt aus der Vereinskollektion?\"",
    "keywords": []
  },
  {
    "id": "exklusivitaet-durch-passwort-geschuetzten-zugang",
    "category": "Vereinsbestellungen",
    "question": "Exklusivität durch Passwort geschützten Zugang?",
    "answer": "Ja. Wir können den Zugang zu deiner Vereinskollektion mit einem Passwort-Zugang schützen. Wir stellen dir dieses Passwort zur Verfügung und du entscheidest, wer etwas aus der Vereinskollektion bestellen darf. So ermöglichen wir dir höchstmögliche Exklusivität.",
    "keywords": []
  },
  {
    "id": "lieferzeiten-bei-vereinsbestellungen",
    "category": "Vereinsbestellungen",
    "question": "Lieferzeiten bei Vereinsbestellungen?",
    "answer": "Bitte beachte, dass die Lieferzeiten bei Vereinsbestellungen, je nach Hersteller, variieren können. Du findest die Lieferzeit auf jeder Seite eines Vereinsprodukts.",
    "keywords": []
  },
  {
    "id": "gibt-es-ein-rueckgaberecht-bei-einer-vereinsbestellung",
    "category": "Vereinsbestellungen",
    "question": "Gibt es ein Rückgaberecht bei einer Vereinsbestellung?",
    "answer": "Nein. Sobald ein Produkt veredelt wurde, also bedruckt etc., ist das Produkt vom Rückgaberecht ausgeschlossen. Gewährleistungsansprüche bleiben vollumfänglich aufrecht.",
    "keywords": []
  },
  {
    "id": "kann-ich-ein-muster-ansehen-und-probieren",
    "category": "Vereinsbestellungen",
    "question": "Kann ich ein Muster ansehen und probieren?",
    "answer": "Du bist dir wegen der Größe oder Schnitt unsicher? Kein Problem. Besuche unsere Filiale in der Plus-City in Pasching. Wir haben von jeder Marke jede Größe lagernd.",
    "keywords": []
  },
  {
    "id": "sind-die-vereinsrabatte-bereits-abgezogen",
    "category": "Vereinsbestellungen",
    "question": "Sind die Vereinsrabatte bereits abgezogen?",
    "answer": "Ja. Der Vereinsrabatt ist bereits abgezogen. Das bedeutet, dass der angezeigte Preis bereits der Preis inkl. Rabatt ist.",
    "keywords": []
  },
  {
    "id": "wie-erhalte-ich-eine-vereinskarte-bzw-machsport-teamkarte",
    "category": "Vereinsbestellungen",
    "question": "Wie erhalte ich eine Vereinskarte bzw. machsport-Teamkarte?",
    "answer": "Dein Verein ist ein Partnerverein von machsport? Jedes Vereinsmitglied kann sich eine machsport-Teamkarte beim Vereinsvorstand oder Trainer abholen. Mit dieser Vorteilskarte bekommst du folgende Vergünstigungen: -20% auf alle Lauf-, Fußball-, Tennis- und Hallenschuhe -10% auf Lauf-, Fußball- und Tenniszubehör -10% auf Fanartikel -10% auf Pulsmesser (ausgenommen Produktneuheiten: -7,5% Rabatt) -30% auf deine Ausrüstermarke Nicht kombinierbar mit anderen Gutscheinen oder Rabattaktionen. Keine Barablöse möglich. Rabatt wird jeweils auf den UVP angewendet. Nicht gültig auf bereits reduzierte Ware sowie auf Fanartikel von FC Blau-Weiß Linz und HC Linz AG.",
    "keywords": []
  },
  {
    "id": "welche-einschraenkungen-gibt-es-beim-vereinsrabatt",
    "category": "Vereinsbestellungen",
    "question": "Welche Einschränkungen gibt es beim Vereinsrabatt?",
    "answer": "Auf alle Produkte der Marke Garmin bekommst du 7,5% Rabatt. Gutscheine sind nicht kombinierbar. Gänzlich vom Rabatt ausgeschlossen sind folgende Produkte: Blau-Weiß Linz Fanartikel HC Linz Fanartikel kein Rabatt auf Serviceleistungen wie Druck, Bespannservice etc.",
    "keywords": []
  },
  {
    "id": "welche-rabatte-erhalte-ich-als-vereinsmitglied-eines-partnervereins",
    "category": "Vereinsbestellungen",
    "question": "Welche Rabatte erhalte ich als Vereinsmitglied eines Partnervereins?",
    "answer": "Dein Verein ist ein Partnerverein von machsport? Jedes Vereinsmitglied kann sich eine machsport-Teamkarte beim Vereinsvorstand oder Trainer abholen. Mit dieser Vorteilskarte bekommst du folgende Vergünstigungen: -20% auf alle Lauf-, Fußball-, Tennis- und Hallenschuhe -10% auf Lauf-, Fußball- und Tenniszubehör -10% auf Fanartikel -10% auf Pulsmesser (ausgenommen Produktneuheiten: -7,5% Rabatt) -30% auf deine Ausrüstermarke Nicht kombinierbar mit anderen Gutscheinen oder Rabattaktionen. Keine Barablöse möglich. Rabatt wird jeweils auf den UVP angewendet. Nicht gültig auf bereits reduzierte Ware & Fanartikel von FC Blau-Weiß Linz und HC Linz AG.",
    "keywords": []
  },
  {
    "id": "in-welchen-dateiformaten-kann-ich-machsport-die-logos-senden-2",
    "category": "Vereinsbestellungen",
    "question": "In welchen Dateiformaten kann ich machsport die Logos senden?",
    "answer": "Bitte sende uns Logos in eines der angeführten Formate. svg eps ai pdf Du kannst die Logos direkt an unsere Grafikabteilung senden, per Mail .",
    "keywords": []
  },
  {
    "id": "dein-persoenlicher-kontakt-fuer-vereinsbestellungen-und-neue-vereine",
    "category": "Vereinsbestellungen",
    "question": "Dein persönlicher Kontakt für Vereinsbestellungen und neue Vereine",
    "answer": "Du hast Fragen rund um deine Vereinsbestellung oder möchtest deinen Verein mit hochwertigen Produkten ausstatten? Kontaktiere mich, ich freue mich auf deine Nachricht: Herr Philipp Hehenberger Mail: ph@moch-sport.shop",
    "keywords": []
  },
  {
    "id": "warum-werden-mir-versandkosten-angezeigt-obwohl-ich-ueber-79-euro-bestelle-2",
    "category": "Vereinsbestellungen",
    "question": "Warum werden mir Versandkosten angezeigt, obwohl ich über 79 Euro bestelle?",
    "answer": "Grundsätzlich ist der Versand nach Österreich und Deutschland ab einem Bestellwert von € 79,00 Euro kostenlos. Eine Ausnahme gilt jedoch für Produkte aus dem Bereich „Mein Verein“, also veredelte Artikel aus Vereinskollektionen. Für diese Produkte fallen immer Versandkosten an – unabhängig vom Bestellwert. Der Grund dafür ist, dass diese Artikel bereits speziell produziert bzw. veredelt und meist stark reduziert sind. Daher ist hier kein kostenloser Versand mehr möglich. Sobald sich ein solcher Artikel im Warenkorb befindet, werden die Versandkosten automatisch korrekt angezeigt. Wenn Du unsicher bist, welche Produkte davon betroffen sind, hilft Dir unser Support gerne weiter.",
    "keywords": []
  },
  {
    "id": "was-ist-das-machsport-partnerprogramm",
    "category": "Partnerprogramm und Affiliate",
    "question": "Was ist das machsport Partnerprogramm?",
    "answer": "Das machsport Partnerprogramm ist eine Möglichkeit, machsport deiner Sport-Community weiterzuempfehlen und bei berechtigten vermittelten Verkäufen eine Provision zu erhalten. Du nutzt dafür deinen persönlichen Affiliate-Link oder Rabattcode.",
    "keywords": []
  },
  {
    "id": "fuer-wen-ist-das-affiliate-programm-von-machsport-geeignet",
    "category": "Partnerprogramm und Affiliate",
    "question": "Für wen ist das Affiliate-Programm von machsport geeignet?",
    "answer": "Das Programm passt zu Creator:innen, Sportler:innen, Trainer:innen, Vereinen, Blogger:innen, Publishern und sportbegeisterten Kund:innen, die Produkte aus Laufen, Fußball, Tennis, Teamsport, Fanartikeln oder Sportzubehör authentisch empfehlen möchten.",
    "keywords": []
  },
  {
    "id": "wie-funktioniert-die-anmeldung-zum-partnerprogramm",
    "category": "Partnerprogramm und Affiliate",
    "question": "Wie funktioniert die Anmeldung zum Partnerprogramm?",
    "answer": "Nach deiner Anmeldung prüfen wir deine Bewerbung manuell. Wenn deine Inhalte, deine Zielgruppe und deine Art der Kommunikation zu machsport passen, erhältst du Zugang zu deinem persönlichen Affiliate-Dashboard.",
    "keywords": []
  },
  {
    "id": "was-bekomme-ich-nach-der-freigabe",
    "category": "Partnerprogramm und Affiliate",
    "question": "Was bekomme ich nach der Freigabe?",
    "answer": "Nach der Freigabe erhältst du Zugriff auf dein Affiliate-Dashboard. Dort findest du deinen individuellen Affiliate-Link und deinen persönlichen Rabattcode, damit vermittelte Käufe sauber zugeordnet werden können.",
    "keywords": []
  },
  {
    "id": "wo-kann-ich-meinen-affiliate-link-oder-rabattcode-teilen",
    "category": "Partnerprogramm und Affiliate",
    "question": "Wo kann ich meinen Affiliate-Link oder Rabattcode teilen?",
    "answer": "Du kannst deinen Link oder Rabattcode dort teilen, wo du deine Community erreichst. Das kann zum Beispiel auf Instagram, TikTok, YouTube, in Blogartikeln, Newslettern, Vereinsgruppen, WhatsApp-Communitys oder auf deiner eigenen Website sein.",
    "keywords": []
  },
  {
    "id": "wie-wird-eine-bestellung-meiner-empfehlung-zugeordnet",
    "category": "Partnerprogramm und Affiliate",
    "question": "Wie wird eine Bestellung meiner Empfehlung zugeordnet?",
    "answer": "Die Zuordnung erfolgt über deinen persönlichen Affiliate-Link oder deinen Rabattcode. Wenn Kund:innen über diesen Link oder mit deinem Code bei machsport einkaufen, kann der vermittelte Verkauf deinem Partnerkonto zugeordnet werden.",
    "keywords": []
  },
  {
    "id": "wann-wird-eine-provision-freigegeben",
    "category": "Partnerprogramm und Affiliate",
    "question": "Wann wird eine Provision freigegeben?",
    "answer": "Provisionen werden nach Prüfung freigegeben. Dabei werden unter anderem Stornos, Retouren oder nicht provisionsfähige Bestandteile berücksichtigt, damit die Abrechnung fair und nachvollziehbar bleibt.",
    "keywords": []
  },
  {
    "id": "muss-ich-meine-affiliate-empfehlung-kennzeichnen",
    "category": "Partnerprogramm und Affiliate",
    "question": "Muss ich meine Affiliate-Empfehlung kennzeichnen?",
    "answer": "Ja. Wenn du machsport bewirbst und dafür eine Provision erhalten kannst, müssen deine Inhalte transparent als Werbung oder Affiliate-Empfehlung gekennzeichnet werden. So bleibt die Zusammenarbeit glaubwürdig und fair.",
    "keywords": []
  },
  {
    "id": "wird-jede-anmeldung-automatisch-angenommen",
    "category": "Partnerprogramm und Affiliate",
    "question": "Wird jede Anmeldung automatisch angenommen?",
    "answer": "Nein. Neue Bewerbungen werden manuell geprüft. Uns ist wichtig, dass Partner:innen zu machsport, unserem Sortiment und unserer Kommunikation passen. Auch kleinere Accounts können interessant sein, wenn die Community aktiv und sportlich relevant ist.",
    "keywords": []
  },
  {
    "id": "was-ist-shopify-collective-bei-machsport",
    "category": "Partnerprogramm und Affiliate",
    "question": "Was ist Shopify Collective bei machsport?",
    "answer": "Shopify Collective ist eine zusätzliche Kooperationsmöglichkeit für Shopify-Händler:innen. Damit kannst du ausgewählte machsport Produkte in deinen eigenen Shopify-Shop übernehmen, ohne diese selbst einlagern zu müssen.",
    "keywords": []
  },
  {
    "id": "wie-funktioniert-shopify-collective-mit-machsport",
    "category": "Partnerprogramm und Affiliate",
    "question": "Wie funktioniert Shopify Collective mit machsport?",
    "answer": "Du verbindest deinen Shopify-Shop mit machsport, erhältst Zugriff auf ausgewählte Produkte und kannst passende Artikel in deinen Store übernehmen. Die Bestellabwicklung, Kommissionierung, Verpackung und der Versand erfolgen anschließend über machsport.",
    "keywords": []
  },
  {
    "id": "was-ist-der-unterschied-zwischen-affiliate-programm-und-shopify-collective",
    "category": "Partnerprogramm und Affiliate",
    "question": "Was ist der Unterschied zwischen Affiliate-Programm und Shopify Collective?",
    "answer": "Beim Affiliate-Programm empfiehlst du machsport über Link oder Rabattcode und kannst Provision auf vermittelte Verkäufe erhalten. Bei Shopify Collective integrierst du ausgewählte machsport Produkte direkt in deinen eigenen Shopify-Shop und erweiterst damit dein Sortiment.",
    "keywords": []
  },
  {
    "id": "kann-ich-auch-mit-kleiner-reichweite-partner-in-werden",
    "category": "Partnerprogramm und Affiliate",
    "question": "Kann ich auch mit kleiner Reichweite Partner:in werden?",
    "answer": "Ja, eine große Reichweite ist nicht automatisch entscheidend. Wichtiger ist, dass deine Community aktiv ist und zu Sport, Bewegung, Training, Verein oder Fanshop passt. Glaubwürdige Empfehlungen sind für uns wichtiger als reine Reichweite.",
    "keywords": []
  },
  {
    "id": "an-wen-kann-ich-mich-bei-fragen-wenden",
    "category": "Partnerprogramm und Affiliate",
    "question": "An wen kann ich mich bei Fragen wenden?",
    "answer": "Bei Fragen zur Anmeldung, zum Affiliate-Link, zu Rabattcodes, zu Shopify Collective oder zu individuellen Kooperationsideen kannst du dich direkt an machsport wenden. Gemeinsam prüfen wir, welche Form der Zusammenarbeit am besten passt. Nähere Informationen zum Parnterpgoramm und Affiliate findest du hier .",
    "keywords": []
  },
  {
    "id": "was-ist-die-machsport-teamkarte",
    "category": "zur machsport teamkarte",
    "question": "Was ist die machsport Teamkarte?",
    "answer": "Die machsport Teamkarte ist ein Vorteil für Mitglieder unserer Partnervereine. Mit dem persönlichen Code auf der Rückseite deiner Karte kannst du deinen Teamkarten-Vorteil jetzt auch im machsport Onlineshop nutzen.",
    "keywords": []
  },
  {
    "id": "wie-verwende-ich-die-teamkarte-online",
    "category": "zur machsport teamkarte",
    "question": "Wie verwende ich die Teamkarte online?",
    "answer": "Gib einfach den Code von der Rückseite deiner Teamkarte im Checkout des machsport Onlineshops ein. Danach wird automatisch geprüft, ob und wie dein Teamkarten-Vorteil auf die Produkte in deiner Bestellung angewendet werden kann.",
    "keywords": []
  },
  {
    "id": "welchen-vorteil-bekomme-ich-mit-der-teamkarte",
    "category": "zur machsport teamkarte",
    "question": "Welchen Vorteil bekomme ich mit der Teamkarte?",
    "answer": "Mit der Teamkarte erhältst du 20 Prozent auf alle Arten von Schuhen und 10 Prozent auf alle anderen Produkte. Der Vorteil wird immer vom UVP beziehungsweise Stattpreis des jeweiligen Produkts berechnet.",
    "keywords": []
  },
  {
    "id": "gilt-der-teamkarten-vorteil-zusaetzlich-auf-bereits-reduzierte-artikel",
    "category": "zur machsport teamkarte",
    "question": "Gilt der Teamkarten-Vorteil zusätzlich auf bereits reduzierte Artikel?",
    "answer": "Nicht automatisch. Entscheidend ist immer der Vergleich zum UVP beziehungsweise Stattpreis. Wenn ein Produkt bereits stärker reduziert ist als dein Teamkarten-Vorteil, bleibt der bereits günstigere Preis bestehen und es gibt keine zusätzliche Reduzierung.",
    "keywords": []
  },
  {
    "id": "was-passiert-wenn-ein-produkt-noch-nicht-stark-genug-reduziert-ist",
    "category": "zur machsport teamkarte",
    "question": "Was passiert, wenn ein Produkt noch nicht stark genug reduziert ist?",
    "answer": "Dann ergänzt die Teamkarte den Vorteil bis zur vorgesehenen Reduzierung vom UVP. Du bekommst also entweder den bereits besseren Aktionspreis oder den Teamkarten-Vorteil, je nachdem, was für dich günstiger ist.",
    "keywords": []
  },
  {
    "id": "warum-sehe-ich-im-checkout-nur-eine-gesamtersparnis",
    "category": "zur machsport teamkarte",
    "question": "Warum sehe ich im Checkout nur eine Gesamtersparnis?",
    "answer": "Shopify zeigt die Ersparnis gesammelt an. Diese Gesamtersparnis kann normale Produktrabatte, bereits reduzierte Verkaufspreise, Gutscheincodes und den Vorteil durch deinen Teamkarten-Code enthalten. Eine getrennte Aufschlüsselung der einzelnen Rabattarten wird im Checkout nicht dargestellt.",
    "keywords": []
  },
  {
    "id": "fuer-welche-produkte-gilt-die-teamkarte-nicht",
    "category": "zur machsport teamkarte",
    "question": "Für welche Produkte gilt die Teamkarte nicht?",
    "answer": "Ausgenommen sind Produkte aus Mein Verein, da diese bereits besonders stark reduziert sind. Auf diese Artikel wird der Teamkarten-Vorteil daher nicht zusätzlich angewendet.",
    "keywords": []
  },
  {
    "id": "wer-bekommt-eine-machsport-teamkarte",
    "category": "zur machsport teamkarte",
    "question": "Wer bekommt eine machsport Teamkarte?",
    "answer": "Die Teamkarte erhalten Mitglieder von Partnervereinen von machsport. Sie ist für berechtigte Teamkarten-Inhaber:innen vorgesehen und an den jeweiligen Verein beziehungsweise die vereinbarte Partnerschaft gebunden.",
    "keywords": []
  },
  {
    "id": "was-kann-ich-tun-wenn-ich-keine-teamkarte-habe",
    "category": "zur machsport teamkarte",
    "question": "Was kann ich tun, wenn ich keine Teamkarte habe?",
    "answer": "Wenn du Mitglied in einem Partnerverein bist, aber noch keine Teamkarte hast, melde dich am besten direkt bei deinem Verein. Alternativ kannst du dich auch an machsport wenden, damit geprüft werden kann, ob dein Verein bereits teilnimmt.",
    "keywords": []
  },
  {
    "id": "was-bedeutet-die-teamkarte-praktisch-fuer-meinen-einkauf",
    "category": "zur machsport teamkarte",
    "question": "Was bedeutet die Teamkarte praktisch für meinen Einkauf?",
    "answer": "Du kannst online bestellen, deinen Teamkarten-Code im Checkout eingeben und bekommst automatisch den für dich passenden Vorteil. Wenn ein Artikel ohnehin schon stärker reduziert ist, bleibt der günstigere Preis bestehen. Wenn dein Teamkarten-Vorteil besser ist, wird dieser entsprechend berücksichtigt.",
    "keywords": []
  },
  {
    "id": "unser-filialnetz",
    "category": "machsport",
    "question": "Unser Filialnetz",
    "answer": "Besuche uns an einem unserer zwei Standorte – ganz in deiner Nähe! Beide Filialen bieten dir eine erstklassige Beratung, umfangreiche Services und eine große Auswahl an Produkten. Komm vorbei und erlebe persönlichen Service und Top-Qualität vor Ort! machsport Store PlusCity Pluskaufstraße 7, 4061 Pasching Montag bis Mittwoch 9:30 Uhr - 19:00 Uhr Donnerstag bis Freitag 9:30 Uhr - 21:00 Uhr Samstag 9:00 Uhr - 18:00 Uhr machsport Store Linz Straßerau 3, 4020 Linz Montag bis Freitag 10:00 Uhr - 18:00 Uhr Samstag 9:00 Uhr - 13:00 Uhr",
    "keywords": []
  },
  {
    "id": "erfuellt-machsport-die-eu-gpsr-produktsicherheitsanforderungen",
    "category": "machsport",
    "question": "Erfüllt machsport die EU GPSR Produktsicherheitsanforderungen?",
    "answer": "Ja. Wir arbeiten laufend an der Erfüllung aller gesetzlichen Vorgaben und darüber hinaus. Transparenz ist uns ein hohes Anliegen.",
    "keywords": []
  },
  {
    "id": "barrierefreiheit",
    "category": "machsport",
    "question": "Barrierefreiheit",
    "answer": "Wir setzen alle erforderlichen Maßnahmen um, damit unsere Website den geltenden Anforderungen des Gesetzes zur Barrierefreiheit von Websites und mobilen Anwendungen (gültig ab Juni 2025) entspricht. Unser Ziel ist es, die Website so zu gestalten, dass sie für alle Menschen, unabhängig von ihren individuellen Fähigkeiten, zugänglich ist. Wir arbeiten kontinuierlich daran, mögliche Barrieren zu identifizieren und zu beheben, um eine möglichst barrierefreie Nutzererfahrung zu gewährleisten. Näheres dazu findest du hier .",
    "keywords": []
  },
  {
    "id": "sind-meine-daten-bei-machsport-sicher-2",
    "category": "machsport",
    "question": "Sind meine Daten bei machsport sicher?",
    "answer": "Deine Daten sind bei uns in besten Händen. Wir setzen auf modernste Sicherheitsstandards, um deine persönlichen Informationen zu schützen. Du kannst dich auf einen sicheren und vertrauenswürdigen Umgang mit deinen Daten verlassen – für ein sorgenfreies Einkaufserlebnis!",
    "keywords": []
  },
  {
    "id": "jobs-bei-machsport",
    "category": "machsport",
    "question": "Jobs bei machsport",
    "answer": "Werde Teil unseres Teams und mach deine Leidenschaft für Sport zu deinem Beruf! Bei machsport warten auf dich ein familiäres Arbeitsumfeld, spannende Aufgaben und die Möglichkeit, dein Wissen und deine Begeisterung für Sport aktiv einzubringen. Wir setzen auf Teamgeist, Entwicklungsmöglichkeiten und faire Arbeitsbedingungen. Wenn du gerne im Sportbereich arbeiten möchtest und Wert auf ein dynamisches, freundliches Team legst, bist du bei uns genau richtig. Gemeinsam bringen wir Bewegung ins Spiel – bewirb dich jetzt hier !",
    "keywords": []
  },
  {
    "id": "fairness-und-transparenz-bei-machsport",
    "category": "machsport",
    "question": "Fairness und Transparenz bei machsport",
    "answer": "Fairness steht bei uns an erster Stelle – ob bei unseren Preisen, unserem Service oder im Umgang mit Kunden und Partnern. Wir legen Wert auf Transparenz und eine vertrauensvolle Zusammenarbeit, damit du dich rundum gut aufgehoben fühlst. Fairness ist unser Versprechen!",
    "keywords": []
  },
  {
    "id": "welche-produkte-verkauft-machsport",
    "category": "machsport",
    "question": "Welche Produkte verkauft machsport?",
    "answer": "Bei uns findest du nur Produkte, die durch Qualität und Langlebigkeit überzeugen. Wir setzen auf renommierte Marken und sorgfältig ausgewählte Artikel, damit du das Beste für deinen Sport bekommst. Verlass dich auf Spitzenqualität, die deine Leistung unterstützt!",
    "keywords": []
  },
  {
    "id": "welche-leistungen-bietet-machsport-fuer-vereine",
    "category": "machsport",
    "question": "Welche Leistungen bietet machsport für Vereine?",
    "answer": "Unser Vereinsservice unterstützt dich und dein Team mit maßgeschneiderten Angeboten. Von Trikots über Zubehör bis hin zu Bedruckung und Sonderkonditionen – wir sind dein zuverlässiger Partner. Gemeinsam sorgen wir dafür, dass dein Verein optimal ausgestattet ist! Erfahre mehr und klicke hier .",
    "keywords": []
  },
  {
    "id": "bietet-machsport-einen-druck-und-stickservice-an",
    "category": "machsport",
    "question": "Bietet machsport einen Druck- und Stickservice an?",
    "answer": "Ja. Verleihe deiner Sportbekleidung eine persönliche Note! Ob Teamlogos, Namen oder individuelle Designs – wir bieten hochwertige Druck- und Stickservices. Perfekt für Vereine, Teams oder deine persönliche Ausrüstung. Qualität und Präzision sind garantiert!",
    "keywords": []
  },
  {
    "id": "wir-stellen-dir-deine-uhr-ein",
    "category": "machsport",
    "question": "Wir stellen dir deine Uhr ein!",
    "answer": "Deine Sportuhr wird von uns präzise eingestellt, damit du direkt loslegen kannst. Egal, ob es um GPS, Herzfrequenz oder Trainingspläne geht – wir sorgen dafür, dass deine Uhr perfekt auf dich abgestimmt ist. Verlass dich auf unseren Expertenservice!",
    "keywords": []
  },
  {
    "id": "du-moechtest-dich-beschweren-oder-hast-eine-reklamation",
    "category": "machsport",
    "question": "Du möchtest dich beschweren oder hast eine Reklamation?",
    "answer": "Das ist Chefsache. Schreibe direkt eine Mail an den Geschäftsführer von machsport, Philipp Hehenberger. Schreibe ihm konstruktiv was dir nicht gefällt und was du dir von ihm erwartest. Feedback ist ihm und dem gesamten Team sehr wichtig. Um Philipp eine Mail zu schreiben, klicke bitte hier .",
    "keywords": []
  }
];

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  var preparedIndex = FAQ_INDEX.map(function (entry) {
    var keywords = Array.isArray(entry.keywords) ? entry.keywords : [];
    var searchText = [
      entry.category,
      entry.question,
      entry.answer
    ]
      .concat(keywords)
      .map(function (part) {
        return normalizeText(part);
      })
      .join(' ');

    return {
      id: entry.id,
      category: entry.category,
      question: entry.question,
      answer: entry.answer,
      keywords: keywords,
      url: FAQ_PAGE_URL + '?faq-search=' + encodeURIComponent(entry.id),
      searchText: searchText
    };
  });

  window.MachsportFaqSearch = {
    pageUrl: FAQ_PAGE_URL,
    index: preparedIndex,
    normalize: normalizeText
  };
})();
